import { render, staticRenderFns } from "./PurchaseForm.vue?vue&type=template&id=3b606310&"
import script from "./PurchaseForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports